<div class="contacts-label-box">
  @for (group of groupedContacts() | keyvalue; track group.key) {
  <div class="key-box">
    <span>{{ group.key }}</span>
  </div>

  @for (contact of $any(group.value); track $index) {
  <div class="contact-label-box" [class.active]="selectService.selectedContact()?.id === contact.id" (click)="selectContact(contact)">
    <span class="initials" [style.backgroundColor]="contact.bgColor">
      {{ getLetters(contact) }}
    </span>
    <div class="info">
      <span class="name">{{ contact.name }} <span *ngIf="isCurrentUser(contact)" class="name">(You)</span></span>
      <span class="mail">{{ contact.mail }}</span>
    </div>
  </div>
  } }
</div>
